export default "__VITE_ASSET__CIaxjav5__"